import { useEffect } from 'react';
import { enUS, es } from 'date-fns/locale';

import i18next from 'i18next';
import { setDefaultOptions } from 'date-fns';

const useDateFnsLocale = () => {
  useEffect(() => {
    const setDateFnsLocale = () => {
      setDefaultOptions({ locale: i18next.language === 'es' ? es : enUS });
    };

    setDateFnsLocale();

    i18next.on('languageChanged', setDateFnsLocale);

    return () => {
      i18next.off('languageChanged', setDateFnsLocale);
    };
  }, []);
};

export default useDateFnsLocale;
